import { api, ApiError } from '../api.js';
import { auth } from '../auth.js';
import { escape, setStatus, statusZone } from '../components/form.js';
import { navigate } from '../router.js';

const STATUS_ID = 'interests-status';
const MIN_INTERESTS = 3;

// Matches the wireframe topic list (Screen 3). Stored lowercased server-side;
// we display them with their emoji here for personality.
const TOPICS = [
  { id: 'football', label: 'Football ⚽' },
  { id: 'movies', label: 'Movies 🎬' },
  { id: 'music', label: 'Music 🎵' },
  { id: 'history', label: 'History 📜' },
  { id: 'science', label: 'Science 🔬' },
  { id: 'geography', label: 'Geography 🌍' },
  { id: 'naija pop', label: 'Naija Pop 🎤' },
  { id: 'tech', label: 'Tech 💻' },
  { id: 'bible', label: 'Bible 📖' },
  { id: 'general', label: 'General 🧠' },
  { id: 'politics', label: 'Politics 🏛️' },
  { id: 'sports', label: 'Sports 🏅' },
];

export async function renderInterests(root) {
  let me = auth.getMe();
  if (!me) {
    try {
      me = await api('/me');
      auth.setMe(me);
    } catch {
      navigate('/login');
      return;
    }
  }
  const selected = new Set((me.interests || []).map((t) => t.toLowerCase()));

  root.innerHTML = `
    <div class="appbar">
      <div class="appbar-title">What do you know?</div>
      <div class="appbar-spacer"></div>
      <button type="button" class="link-button" id="skip-btn">Skip</button>
    </div>

    <div class="pad">
      <p class="lede-muted">Pick at least ${MIN_INTERESTS} — we'll match you to the right games.</p>

      <div class="topic-grid" id="topic-grid">
        ${TOPICS.map(
          (t) => `
            <button type="button" class="pill ${selected.has(t.id) ? 'on' : ''}" data-topic="${escape(t.id)}">
              ${escape(t.label)}
            </button>
          `,
        ).join('')}
      </div>

      ${statusZone(STATUS_ID)}

      <button type="button" class="btn" id="continue-btn" style="margin-top:24px;">
        Continue
      </button>
    </div>
  `;

  const grid = document.getElementById('topic-grid');
  const continueBtn = document.getElementById('continue-btn');

  function refreshButton() {
    const count = selected.size;
    if (count < MIN_INTERESTS) {
      continueBtn.textContent = `Pick ${MIN_INTERESTS - count} more`;
      continueBtn.disabled = true;
    } else {
      continueBtn.textContent = 'Continue';
      continueBtn.disabled = false;
    }
  }
  refreshButton();

  grid.addEventListener('click', (e) => {
    const chip = e.target.closest('.pill');
    if (!chip) return;
    const topic = chip.dataset.topic;
    if (selected.has(topic)) {
      selected.delete(topic);
      chip.classList.remove('on');
    } else {
      selected.add(topic);
      chip.classList.add('on');
    }
    refreshButton();
  });

  document.getElementById('skip-btn')?.addEventListener('click', () => navigate('/'));

  continueBtn.addEventListener('click', async () => {
    setStatus(STATUS_ID, { message: 'Saving…', kind: 'info' });
    continueBtn.disabled = true;
    try {
      const updated = await api('/me', {
        method: 'PATCH',
        body: { interests: [...selected] },
      });
      auth.setMe(updated);
      setStatus(STATUS_ID, { message: 'Saved.', kind: 'success' });
      setTimeout(() => navigate('/'), 400);
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : 'Could not save.';
      setStatus(STATUS_ID, { message: msg, kind: 'error' });
      refreshButton();
    }
  });
}
